import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  ShowButton,
  FilterButton,
  ExportButton,
  DateField,
  FunctionField,
  useRecordContext,
} from 'react-admin';
import NestedReferenceField from '../../components/NestedReferenceField';

const HorseNameField = () => {
  const record = useRecordContext();
  if (!record || !record.horse) return null;
  if (typeof record.horse === 'string') return <span>{record.horse}</span>;
  return <span>{record.horse.name ?? record.horse.external_id}</span>;
};

const VetCaseList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'id', order: 'DESC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <FunctionField label="Horse" render={() => <HorseNameField />} sortable={false} />
        <NestedReferenceField source="team" labelField="name" resource="teams" label="Team" />
        <TextField source="case_number" label="Case number" />
        <TextField source="vet_name" label="Vet name" />
        <DateField source="creation_date" label="Created at" showTime />
        <ShowButton />
      </DatagridConfigurable>
    </List>
  );
};

export default VetCaseList;
